import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, LogOut, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { Button } from '@/components/ui/button';

export default function Header() {
  const { user, logout } = useAuth();
  const { getCartCount } = useCart();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <div className="text-2xl font-bold bg-gradient-to-r from-[#FF6B35] to-[#ff8c5a] bg-clip-text text-transparent">
              ShipShop
            </div>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-[#FF6B35] font-medium transition-colors" data-testid="nav-home">
              Home
            </Link>
            <Link to="/products" className="text-gray-700 hover:text-[#FF6B35] font-medium transition-colors" data-testid="nav-products">
              Products
            </Link>
          </nav>

          {/* Right Side */}
          <div className="flex items-center space-x-4">
            {/* Cart */}
            <Link to="/cart" className="relative" data-testid="cart-icon">
              <Button variant="ghost" size="icon" className="relative">
                <ShoppingCart className="h-5 w-5 text-gray-700" />
                {getCartCount() > 0 && (
                  <span className="absolute -top-1 -right-1 bg-[#FF6B35] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-semibold" data-testid="cart-count">
                    {getCartCount()}
                  </span>
                )}
              </Button>
            </Link>

            {/* User Menu */}
            {user ? (
              <div className="flex items-center space-x-2">
                {user.is_admin && (
                  <Link to="/admin" data-testid="admin-link">
                    <Button variant="ghost" size="icon">
                      <LayoutDashboard className="h-5 w-5 text-gray-700" />
                    </Button>
                  </Link>
                )}
                <Link to="/dashboard" data-testid="dashboard-link">
                  <Button variant="ghost" size="icon">
                    <User className="h-5 w-5 text-gray-700" />
                  </Button>
                </Link>
                <Button variant="ghost" size="icon" onClick={handleLogout} data-testid="logout-button">
                  <LogOut className="h-5 w-5 text-gray-700" />
                </Button>
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Link to="/login" data-testid="login-link">
                  <Button variant="ghost" className="text-gray-700 hover:text-[#FF6B35]">
                    Login
                  </Button>
                </Link>
                <Link to="/register" data-testid="register-link">
                  <Button className="bg-[#FF6B35] hover:bg-[#ff8c5a] text-white rounded-full">
                    Sign Up
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
